import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Grid, Button } from 'semantic-ui-react';
import { Formik } from 'formik';
import _ from 'lodash';

/** Services */
import RecessoService from 'shared/services/api/recesso';

/** Components */
import SingleSelect from '../../Forms/UI/Select';

class UpdateStateRecesso extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /** Update state on DB */
  onSubmit = (values, { setSubmitting }) => {
    // Prepare payload
    const payload = {
      state: _.isObject(values.state) ? values.state.value : values.state,
    };

    // Call api
    RecessoService.patchRecesso(this.props.recesso.id, payload)
      .then(() => {
        this.props.notification().addNotification({
          message: 'Aggiornamento stato completato con successo',
          level: 'success',
        });
        this.props.closeModal();
        this.props.loadData();
      })
      .catch((err) => {
        // Update form
        setSubmitting(false);

        // Show message error
        this.props.notification().addNotification({
          message:
            _.get(err, 'data.detail') ||
            "Errore nell'aggiornare lo stato, se il problema persiste contatta l'assistenza",
          level: 'error',
        });
      });
  };

  /** Define options for select */
  getStateActions = () => {
    let stateOptions = [
      { key: 'state-2', label: 'Attesa RA', value: 1 },
      { key: 'state-3', label: 'Attesa comunicazione da collaboratore', value: 2 },
      { key: 'state-4', label: 'Attesa decorrenza', value: 3 },
      { key: 'state-5', label: 'Rescisso', value: 4 },
      { key: 'state-6', label: 'Non perfezionato', value: 5 },
      { key: 'state-7', label: 'Notizia di recesso', value: 6 },
    ];

    // Remove actual state from list
    stateOptions = stateOptions.filter((item) => item.value !== this.props.recesso.state);

    // Remove state 'Rescisso' if data Recisso isn't defined
    if (!this.props.recesso.withdrawalDate) {
      stateOptions = stateOptions.filter((item) => item.value !== 4);
    }


    // Return list
    return stateOptions;
  };

  render() {
    const { closeModal } = this.props;

    return (
      <Modal.Content>
        <Formik
          enableReinitialize
          initialValues={{
            state: null,
          }}
          onSubmit={this.onSubmit}
        >
          {({ isSubmitting, handleSubmit, setFieldTouched, setFieldValue, touched, values }) => (
            <Form autoComplete="off" onSubmit={handleSubmit} loading={isSubmitting}>
              <Grid>
                <Grid.Row>
                  <Grid.Column key="form-update-state">
                    <SingleSelect
                      label="Stato"
                      name="state"
                      onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                      onChange={(name, value) => setFieldValue(name, value)}
                      options={this.getStateActions()}
                      touched={touched.state}
                      value={values.state}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Column width={8} textAlign="left">
                  <Button.Group>
                    <Button
                      onClick={closeModal}
                      type="button"
                      icon="delete"
                      labelPosition="right"
                      content="Chiudi"
                      style={{ marginRight: '20px', width: '150px' }}
                    />
                  </Button.Group>
                </Grid.Column>
                <Grid.Column width={8} textAlign="right">
                  <Button
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    type="button"
                    icon="save"
                    labelPosition="right"
                    positive
                    disabled={isSubmitting}
                    content="Salva"
                    style={{ width: '150px' }}
                  />
                </Grid.Column>
              </Grid>
            </Form>
          )}
        </Formik>
      </Modal.Content>
    );
  }
}

UpdateStateRecesso.propTypes = {
  /** Current recesso data */
  recesso: PropTypes.object.isRequired,
  /** Function to reload list of recesso */
  loadData: PropTypes.func.isRequired,
  /** Funtion to close modal  */
  closeModal: PropTypes.func.isRequired,
  /** Function to notificate */
  notification: PropTypes.func.isRequired,
};

export default UpdateStateRecesso;



// WEBPACK FOOTER //
// ./app/components/RecessoList/UpdateStateRecesso/index.js